/**
 * XNGAGE CONFIDENTIAL
 * __________________________
 *
 * Copyright (C) 2020 Xngage - All Rights Reserved
 *
 * All code or information contained herein is, and remains the
 * property of Xngage LLC and its customers.  The intellectual
 * and technical concepts contained are proprietary to Xngage LLC
 * and may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Xngage LLC.
 */

/**
 * Override this OOTB component, in order to add option to hide
 * the current page from the breadcrumb, this is used in PDP.
 */

import { breadcrumbStyles } from "@eisinc/App/SharedStyles/GeneralStyles";
import Breadcrumbs from "@eisinc/MobiusOverrides/Breadcrumbs";
import { generateLinksFrom } from "@insite/client-framework/Components/PageBreadcrumbs";
import ApplicationState from "@insite/client-framework/Store/ApplicationState";
import { getCurrentPage } from "@insite/client-framework/Store/Data/Pages/PageSelectors";
import { getHomePageUrl } from "@insite/client-framework/Store/Links/LinksSelectors";
import translate from "@insite/client-framework/Translate";
import React, { FC } from "react";
import { connect } from "react-redux";

type OwnProps = {
    hideCurrentPage?: boolean;
};

const mapStateToProps = (state: ApplicationState) => {
    const homePageUrl = getHomePageUrl(state);

    return {
        links: state.components.breadcrumbs.links,
        linksState: state.links,
        nodeId: getCurrentPage(state).nodeId,
        homePageUrl,
    };
};

type Props = OwnProps & ReturnType<typeof mapStateToProps>;

const homePageLink = { children: translate("Home"), href: "/" };

const PageBreadcrumbs: FC<Props> = (props: Props) => {
    let links = props.links || generateLinksFrom(props.linksState, props.nodeId, props.homePageUrl);
    if (links.length > 0 && links[0].href !== homePageLink.href) {
        links = [homePageLink, ...links];
    }

    return (
        <Breadcrumbs
            {...breadcrumbStyles}
            hideCurrentPage={props.hideCurrentPage}
            links={links}
            data-test-selector="pageBreadcrumbs"
        />
    );
};

export default connect(mapStateToProps)(PageBreadcrumbs);
